export default function Marquee() {
    const items = [
        'استطلاعات مختارة بعناية',
        'دفع فوري وشفاف',
        'مكافآت تصل حتى 50$',
        'بلا حشو، بلا وعود مبالغة',
        'مراجعة يدوية لكل رابط',
        'استطلاعات مختارة بعناية',
        'دفع فوري وشفاف',
        'مكافآت تصل حتى 50$',
        'بلا حشو، بلا وعود مبالغة',
        'مراجعة يدوية لكل رابط',
    ];
    return (
        <section
            className="relative border-y border-ink bg-ink text-sand-100 py-6 overflow-hidden"
            data-testid="marquee-section"
            dir="ltr"
        >
            <div className="marquee">
                <div className="marquee__track">
                    {items.map((t, i) => (
                        <span
                            key={`a-${i}`}
                            className="font-display font-bold text-2xl md:text-4xl tracking-tight flex items-center gap-10"
                        >
                            {t}
                            <span className="text-emerald-signal">✦</span>
                        </span>
                    ))}
                </div>
                <div className="marquee__track" aria-hidden>
                    {items.map((t, i) => (
                        <span
                            key={`b-${i}`}
                            className="font-display font-bold text-2xl md:text-4xl tracking-tight flex items-center gap-10"
                        >
                            {t}
                            <span className="text-emerald-signal">✦</span>
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
